module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading || (_vm.posts.length === 0 && _vm.isLoading === false)),
      expression: "isLoading || (posts.length === 0 && isLoading === false)"
    }],
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "width": "100%"
    },
    style: ({
      'height': _vm.loaderHeight + 'px'
    })
  }, [_c('div', {
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('img', {
    staticClass: "rounded",
    attrs: {
      "width": "100px",
      "src": "static/loader-gif.gif"
    }
  }), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.$t('message.loadingText')) + "\n    ")])]), _vm._v(" "), (_vm.isLoading === false && _vm.posts.length > 0) ? _c('div', {
    attrs: {
      "id": "lifeView"
    }
  }, [_c('div', {
    staticClass: "life-header",
    style: (("background-position: center center;background-size: cover;background-image: linear-gradient(180deg,rgba(0,0,0,.68),rgba(0,0,0,.68)),url(" + (_vm.posts[0].post_image) + ");"))
  }, [_c('span', [_vm._v("Trending now")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.posts[0].post_title))]), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "to": ("life/" + (_vm.posts[0].post_slug)),
      "label": "Read now"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "100"
    }
  }, [_c('life-search-bar')], 1)], 1), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "75"
    }
  }, [(_vm.hasRecommendations && !_vm.isHcpView) ? _c('div', {
    staticClass: "section",
    attrs: {
      "id": "lifeRecommendations"
    }
  }, [_c('h2', [_vm._v("Recommended reading")]), _vm._v(" "), _c('mu-flexbox', {
    attrs: {
      "justify": "flex-start",
      "align": "stretch",
      "wrap": "wrap"
    }
  }, _vm._l((_vm.shuffleRecommendations), function(post, index) {
    return (index <= 2) ? _c('mu-flexbox-item', {
      key: ("recommendation-" + index),
      attrs: {
        "basis": "25%"
      }
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1) : _vm._e()
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('h2', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.lifeBrowseCategory'))
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "listCats"
    }
  }, [_c('div', {
    staticClass: "cat-col"
  }, [_c('mu-card', {
    staticClass: "cat",
    staticStyle: {
      "background-image": "url('static/life/coffee-heart.jpg')"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/life/my-favourites"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFavourites()
      }
    }
  }, [_c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "catMeta"
  }, [_c('h3', {
    staticClass: "title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.lifeMyFavourites'))
    }
  })])])])], 1)], 1), _vm._v(" "), _vm._l((_vm.cats), function(cat, index) {
    return (cat.count !== 0) ? _c('div', {
      key: 'cat-' + index,
      staticClass: "cat-col"
    }, [_c('mu-card', {
      staticClass: "cat",
      style: ({
        'background-image': 'url(' + cat.image + ')'
      })
    }, [_c('router-link', {
      attrs: {
        "to": {}
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(cat.slug)
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "catMeta"
    }, [_c('h3', {
      staticClass: "title",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.localizeLifeCat(cat.term_id) || cat.name))
      }
    }), _vm._v(" "), _vm._o(_c('span', {
      staticClass: "count"
    }, [_vm._v(_vm._s(cat.count) + " " + _vm._s(cat.count === 1 ? _vm.$t('message.labelArticle') : _vm.$t('message.labelArticles')))]), 0, 'cat-' + index)])])])], 1)], 1) : _vm._e()
  })], 2)])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "tablet": "100",
      "desktop": "25"
    }
  }, [(_vm.posts.length) ? _c('div', {
    attrs: {
      "id": "lifeSideBar"
    }
  }, _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      key: ("sidepost-" + index),
      staticClass: "sidePost"
    }, [_c('life-post-info', {
      attrs: {
        "slug": post.post_slug,
        "image": post.post_image,
        "title": post.post_title,
        "time": post.post_date,
        "favourites": post.post_favourites
      }
    })], 1)
  }), 0) : _vm._e()])], 1)], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc52943","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/LifeStyle/LifeStyle.vue
// module id = 3591
// module chunks = 1